<template>
  <section v-if="cardList.length > 0" class="main-card">
    <div class="main-title">
      <html-view :value="$t('main.card.title')" tag="h3" />
      <html-view :value="$t('main.card.subtitle')" tag="small" />
    </div>
    <div ref="cardSwiper" class="main-content">
      <div v-if="cardList.length > 0" class="card-list">
        <div
          v-for="(item, key) in cardList"
          :key="key"
          class="card"
        >
          <a :href="item.cardUrl" :target="setTarget(item.cardUrl)">
            <span class="card-image">
              <img :src="item.cardImagePath" alt="">
            </span>
            <span class="card-text">{{ item.cardCopy }}</span>
          </a>
        </div>
        <div v-if="cardList.length <= 0" class="empty">
          empty
        </div>
      </div>
      <div ref="cardPagination" class="swiper-pagination" />
    </div>
  </section>
</template>

<script>
import mainApi from '@/api/main'
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay])

export default {
  data () {
    return {
      cardSlider: null,
      cardList: [],
    }
  },
  watch: {
    '$route.params.locale' () {
      if (this.cardSlider) {
        this.cardSlider.destroy()
      }
      this.getList()
    }
  },
  beforeDestroy () {
    if (this.cardSlider) {
      this.cardSlider.destroy()
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      const { data } = await mainApi.getCardList()

      this.cardList = data.filter((item, i) => {
        return i < 16
      })

      if (this.cardList.length > 0) {
        this.$nextTick(this.setCardSwiper)
      }
    },
    setCardSwiper () {
      const options = {
        autoplay: {
          delay: 1,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        loop: true,
        spaceBetween: 0,
        // centerInsufficientSlides: true,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        freeMode: {
          enabled: true,
          momentum: false
        },
        grabCursor: true,
        speed: 3000,
        mousewheel: {
          releaseOnEdges: true,
        },
        slideClass: 'card',
        wrapperClass: 'card-list',
        // breakpoints: {
        //   // when window width is >= 280px
        //   280: {
        //     slidesPerGroup: 3,
        //   },
        //   // when window width is >= 980px
        //   980: {
        //     slidesPerGroup: 8,
        //   }
        // },
        // pagination: {
        //   el: this.$refs.cardPagination,
        //   type: 'bullets',
        //   clickable: true,
        //   renderBullet: function (index, className) {
        //     return `<button type="button" class="${className}">${index + 1}</button>`
        //   },
        //   bulletActiveClass: 'active',
        //   bulletClass: 'swiper-pagination-bullet',
        //   bulletElement: 'button',
        //   modifierClass: ''
        // },
        // navigation: false
      }

      this.cardSlider = new Swiper(this.$refs.cardSwiper, options)
    },
    setTarget (link) {
      if (/(?:[\w.]*?)(?:[beta]?)woowahan.com/.test(link)) {
        return '_self'
      } else {
        return '_blank'
      }
    },
  }
}
</script>
